import { useApiDown } from "../lib/apiStatus.js";
import { useT } from "../lib/i18n/store.js";

/**
 * The "maintenance" screen shown over the whole site while the API is down —
 * in practice, the minute or two of a redeploy. It clears itself when the API
 * answers again (see lib/apiStatus.ts); nothing underneath is unmounted, so an
 * editor with unsaved changes is exactly as the author left it. Styled as an
 * intermission card over a backstage picture.
 */
export function MaintenanceScreen() {
  const down = useApiDown();
  const t = useT();
  if (!down) return null;
  return (
    <div
      className="maintenance"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="maintenance-title"
      aria-describedby="maintenance-text"
    >
      <div className="maintenance-art" aria-hidden="true" />
      <div className="maintenance-card">
        <p className="maintenance-eyebrow">
          <span className="maintenance-rule" aria-hidden="true" />
          {t("maintenance.eyebrow")}
          <span className="maintenance-rule" aria-hidden="true" />
        </p>
        <h1 id="maintenance-title">{t("maintenance.title")}</h1>
        <p id="maintenance-text" className="maintenance-text">
          {t("maintenance.text")}
        </p>
        <p className="maintenance-note">
          <svg className="maintenance-note-icon" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          {t("maintenance.drafts")}
        </p>
        <div className="maintenance-progress" aria-hidden="true">
          <span />
        </div>
        <p className="maintenance-status" role="status">
          {t("maintenance.checking")}
        </p>
      </div>
    </div>
  );
}
